import { storage } from '@/services/storage'
import { salesTable } from '@/services/axios'

export default {
    methods: {
        /**
         * RETORNA A PERIODICIDADE EM MESES
         * @param frequency
         */
        facGetFrequency(frequency) {
            let parcelTypes = JSON.parse(storage.get('parcel_types'));
            if(!frequency) return { type: 'Mensal', period: 1, balloon: false, unique: true }
            return parcelTypes.find(parcelType => parcelType.value === frequency)
        },
        /**
         * CALCULO PARA OBTER O VALOR DA ENTRADA
         * @param valor
         * @param taxa
         * @returns {number}
         */
        facInputValue(value, rate) {

            return value * (rate / 100)
        },

        /**
         * CALCULO PARA OBTER VALOR COM DESCONTO
         * @param valor
         * @param taxa
         * @returns {number}
         */
        facValueDiscount(value, discount, quota) {

            var newValue = (value - (value * (discount / 100))) / quota
            return newValue.toFixed(2)
        },

        /**
         * CALCULA O VALOR DA UNIDADE SEM TAXA DE JUROS
         * @param valor
         * @param taxa
         * @returns {number}
         */
        facValueWithoutInterestRate ( value, discount, quota, fixedValue, installments) {
            let valueDiscount  = ( value * discount )

            if(installments){
                let allInstallments     = []
                let balanceOwed         = value
                let valueInterest       = 0
                let valueInstallments   = 0
                let amortization        = 0

                for (let count = 1; count <= quota; count++){
                    //VALOR DAS PARCELAS
                    valueInstallments      = ( valueDiscount - fixedValue ) / quota
                    //VALOR DO JURO
                    valueInterest          = 0
                    //VALOR DA AMORTIZAÇÃO
                    amortization           = 0
                    //PEGA SALDO DEVEDOR
                    balanceOwed            = 0
                    //MONTA OBJETO
                    let data               = {portion:count, amortization: amortization.toFixed(2), valueInterest: valueInterest.toFixed(2), valueInstallments: valueInstallments.toFixed(2), balanceOwed: balanceOwed.toFixed(2), date: ''}
                    allInstallments.push(data)
                }

                return allInstallments
            }

            var newValue = ( valueDiscount - fixedValue ) / quota
            return newValue.toFixed( 2 )
        },

        /**
         * CALCULO PARA TAXA DE JUROS
         * @param taxa
         * @param $meses
         * @returns {number}
         */
        facGetInterestRate(rate, months) {
            return Math.pow((rate / 100) + 1, months)
        },

        /**
         * Conversao de Juros
         * @param taxa
         * @param mesesConversao
         * @returns {number}
         */
        facConvertInterest(rate, months) {   
            let result = (this.facGetFV(1, rate, months) - 1) * 100;
            return parseFloat(result.toFixed(4));
        },
            /**
         * Conversao de Juros Simulação vertical
         * @param taxa
         * @param mesesConversao
         * @returns {number}
         */
        facConvertInterestVertical(rate, months) {   
            let result = (this.facGetFV(1, rate, months) - 1) * 100;
            return parseFloat(result);
        },

        /**
         *CALCULO PARA OBTER VALOR FUTURO
        * @param $valor
        * @param $taxa
        * @param $meses
        * @returns {number}
        */
        facGetFV(value, rate, months) {

            return value * this.facGetInterestRate(rate, months)
        },
               /**
         *CALCULO PARA OBTER VALOR FUTURO SIMULADOR VERTICAL
        * @param $valor
        * @param $taxa
        * @param $meses
        * @param $days 
        * @returns {number}
        */
         facGetFVVertical(value, rate, months,days) {
            let result = value * this.facGetInterestRate(rate, months)
            if (days) {
                let dRate = Math.pow(1 + (rate / 100), 1 / 30) -1;
                result  = result * Math.pow(1 + dRate, days);
            }
            return result
        },


        /**
         * CALCULO PARA OBTER PORCENTAGEM DA PARCELA COM JUROS
         * Adição de validação pra caso o valor venha zerado, retornar zero pra que não tenha divisão por zero
         * @param $valor
         * @param $taxa
         * @param $meses
         * @returns {number}
         */
        facGetPercentageFromPv(value, valueInstallment, rate, months, offset = 0) {
            if (parseInt(value) == 0) return 0;
            let percent = this.facGetPv(valueInstallment, rate, months, offset) / value * 100
            return percent.toFixed(20)
        },

        /**
         * CALCULO PARA OBTER PORCENTAGEM DA PARCELA COM JUROS QUANDO FOR SIMULAÇÂO VERTICAL
         * @param $valor
         * @param $taxa
         * @param $meses
         * @returns {number}
         */
        facGetPercentageFromPvVertical(value, valueInstallment, rate, months, offset = 0) {
            let percent = this.facGetPvPmt(valueInstallment*months, rate, offset) / value * 100
            return percent.toFixed(20)
        },

        /**
         * CALCULO PARA OBTER PORCENTAGEM DA PARCELA TABELA SAC
         * @param $valor
         * @param $taxa
         * @param $meses
         * @returns {number}
         */
        facGetPercentageFromPvSac(value, pmt, rate, months) {

            if(months && months > 0) {

                let percentMax      = 100
                let percentMaxOld   = 0
                let percentMin      = percentMax / 2
                let percentMinOld   = 0
                let percentRest     = percentMin / 2
                let newPmt          = 0
                let maxPmt          = this.facGetInstallmentSac(value, rate, months)
                let newValue        = 0
                let interactions    = 0
                let percent         = percentMin

                for (let count = 0; count <= 100; count++) {

                    interactions++
                    //PEGA NOVO VALOR DO FINANCIAMENTO
                    newValue = (value * (percent / 100))

                    //PEGA VALOR DA NOVA PARCELA
                    newPmt   = this.facGetInstallmentSac(newValue, rate, months)

                    //COMPARA SE PARCELA DIGITATE COM NOVA PARCELA
                    if (parseFloat(pmt) === parseFloat(newPmt)) {
                        console.log(interactions)
                        break
                    }

                    //VERIFICA SE O QUE FOI DIGITADO NA PARCELA E MENOR QUE 100 DO VALOR FINANCIADO
                    if(parseFloat(pmt) < parseFloat(maxPmt)) {
                        if (parseFloat(pmt) > parseFloat(newPmt)) {
                            //TRAVA NO ULTIMO PERCENTUAL MIN
                            percentMinOld = percentMin
                            //AJUSTA PERCENTUAL MIN
                            percentMin   += percentRest
                            //DIVISÃO DO RESTO
                            percentRest   = percentRest / 2
                            percent       = percentMin
                        } else {
                            //AJUSTA PERCENTUAL MIN
                            percentMin    = percentMinOld + percentRest
                            //DIVISÃO DO RESTO
                            percentRest   = percentRest / 2
                            percent       = percentMin
                        }
                    }else{
                        //VALOR DIGITADO MAIOR QUE A PARCELA MAX DO VALOR FINANCIADO
                        //COMPARA SE PARCELA DIGITATE COM NOVA PARCELA
                        if (parseFloat(pmt) > parseFloat(newPmt)) {
                            //TRAVA NO ULTIMO PERCENTUAL MIN
                            percentMaxOld = percentMax
                            //AJUSTA PERCENTUAL MIN
                            percentMax   += percentRest
                            //DIVISÃO DO RESTO
                            // percentRest   = percentRest / 2
                            percent       = percentMax
                        } else {
                            //TRAVA NO ULTIMO PERCENTUAL MIN
                            //DIVISÃO DO RESTO
                            percentRest   = percentRest / 2
                            //AJUSTA PERCENTUAL MIN
                            percentMax    = percentMaxOld + percentRest
                            percent       = percentMax
                        }
                    }
                }

                return (newValue / value) *100
            }
            return 0
        },

        /**
         * CALCULO PARA OBTER PORCENTAGEM DA PARCELA TABELA SACOC
         * @param $valor
         * @param $taxa
         * @param $meses
         * @returns {number}
         */
        facGetPercentageFromPvSacoc(value, pmt, rate, months) {
            if(months && months > 0) {

                let percentMax      = 100
                let percentMaxOld   = 0
                let percentMin      = percentMax / 2
                let percentMinOld   = 0
                let percentRest     = percentMin / 2
                let newPmt          = 0
                let maxPmt          = this.facGetInstallmentSac(value, rate, months)
                let newValue        = 0
                let interactions    = 0
                let percent         = percentMin

                for (let count = 0; count <= 100; count++) {

                    interactions++
                    //PEGA NOVO VALOR DO FINANCIAMENTO
                    newValue = (value * (percent / 100))

                    //PEGA VALOR DA NOVA PARCELA
                    newPmt   = this.facGetInstallmentSacoc(newValue, rate, months)

                    //COMPARA SE PARCELA DIGITATE COM NOVA PARCELA
                    if (parseFloat(pmt) === parseFloat(newPmt)) {
                        console.log(interactions)
                        break
                    }

                    //VERIFICA SE O QUE FOI DIGITADO NA PARCELA E MENOR QUE 100 DO VALOR FINANCIADO
                    if(parseFloat(pmt) < parseFloat(maxPmt)) {
                        if (parseFloat(pmt) > parseFloat(newPmt)) {
                            //TRAVA NO ULTIMO PERCENTUAL MIN
                            percentMinOld = percentMin
                            //AJUSTA PERCENTUAL MIN
                            percentMin   += percentRest
                            //DIVISÃO DO RESTO
                            percentRest   = percentRest / 2
                            percent       = percentMin
                        } else {
                            //AJUSTA PERCENTUAL MIN
                            percentMin    = percentMinOld + percentRest
                            //DIVISÃO DO RESTO
                            percentRest   = percentRest / 2
                            percent       = percentMin
                        }
                    }else{
                        //VALOR DIGITADO MAIOR QUE A PARCELA MAX DO VALOR FINANCIADO
                        //COMPARA SE PARCELA DIGITATE COM NOVA PARCELA
                        if (parseFloat(pmt) > parseFloat(newPmt)) {
                            //TRAVA NO ULTIMO PERCENTUAL MIN
                            percentMaxOld = percentMax
                            //AJUSTA PERCENTUAL MIN
                            percentMax   += percentRest
                            //DIVISÃO DO RESTO
                            // percentRest   = percentRest / 2
                            percent       = percentMax
                        } else {
                            //TRAVA NO ULTIMO PERCENTUAL MIN
                            //DIVISÃO DO RESTO
                            percentRest   = percentRest / 2
                            //AJUSTA PERCENTUAL MIN
                            percentMax    = percentMaxOld + percentRest
                            percent       = percentMax
                        }
                    }
                }

                return (newValue / value) *100
            }
            return 0
        },

        /**
         * CALCULO PARA OBTER VALOR PRESENTE
         * @param $valor
         * @param $taxa
         * @param $meses
         * @returns {number}
         */
        facGetPv(valueInstallment, rate, months, offset = 0) {
            rate = parseFloat(rate) / 100.0

            return valueInstallment * ((Math.pow((1 + rate), months) - 1) / (Math.pow((1 + rate), months + offset) * rate))
        },

        /**
         * CALCULO PARA OBTER VALOR PRESENTE POR PARCELAS
         * @param $valor
         * @param $taxa
         * @param $meses
         * @returns {number}
         */
        facGetPvPmt(valueInstallment, rate, months) {

            rate = parseFloat(rate) / 100.0
            return valueInstallment / Math.pow(1 + rate, months)
        },

        /**
         * Função PGTO para o cálculo de uma parcela
         *
         * @param {Float} rate Taxa de juros convertida (mensal, bimestral, trimestral, etc...)
         * @param {Number} months Período de pagamento (quantidade de parcelas)
         * @param {Float} pv Valor presente da parcela a ser pago
         * @param {Float} fv Valor futuro da parcela (opcional)
         * @param {Number} type Vencimento dos pagamentos: 0 (End) ou 1 (Begin)
         * @returns 
         */
        facGetPGTO(rate, months, pv, fv = 0, type = 0) {
            if (rate === 0) return -(pv + fv) / months

            rate = parseFloat(rate) / 100.0
            let pvif = Math.pow(1 + rate, months)
            let pmt = rate / (pvif - 1) * -(pv * pvif + fv)
        
            if (type === 1) {
                pmt /= (1 + rate)
            }

            return pmt
        },

        /**
         * CALCULO PARA OBTER PORCENTAGEM DA PARCELA SEM JUROS
         * @param value
         * @param valueInstallment
         * @param months
         * @returns {string}
         */
        facGetPercentFromPvWithoutInterest(valueTotal, valueInstallment, months) {
            if (parseInt(valueTotal) == 0) return 0;
            let percent = ((valueInstallment * months) * 100) / valueTotal
            return percent.toFixed(20)
        },

        /**
         * CALCULO PARA OBTER AMORTIZACAO - SAC e SACOC
         * @param $valor
         * @param $taxa
         * @param $meses
         * @returns {number}
         */
        facGetAmortization(value, months) {

            return value / months
        },

        monthDiff(d1, d2) {
            let months
            months = (d2.getFullYear() - d1.getFullYear()) * 12
            months -= d1.getMonth()
            months += d2.getMonth()
            return months
        },

        /**
         * CALCULO PARA OBTER PARCELA PRICE
         * @param valor
         * @param taxa
         * @param meses
         * @returns {*}
         * facGetInstallmentPrice
         */
        facGetInstallmentPrice(value, rate, period, months, installments, paymentOffset) {
            let offset       = paymentOffset || 0
            let fv = 0
            if (period > 1 && offset) {
                fv = this.facGetFV(value, rate, (period * months) + offset)

            } else {
                fv = this.facGetFV(value, this.facConvertInterest(rate, period), parseInt(months)+offset)
            }
            rate = this.facConvertInterest(rate, period)
            let rateConvert  = (rate / 100)
            let interestRate = this.facGetInterestRate(rate, months)

            if (installments) {
                let allInstallments     = []
                let balanceOwed         = value
                let valueInterest       = 0
                let valueInstallments   = 0
                let amortization        = 0
                let pv                  = 0

                for (let count = 1; count <= months; count++){
                    //VALOR DAS PARCELAS
                    valueInstallments      = rateConvert * (fv / (interestRate - 1))
                    //VALOR DO JURO
                    valueInterest          = balanceOwed * rateConvert
                    //VALOR DA AMORTIZAÇÃO
                    amortization           = valueInstallments - valueInterest
                    //PEGA SALDO DEVEDOR
                    balanceOwed            = balanceOwed + valueInterest - valueInstallments
                    //PAGA VALOR DO PV
                    pv                     = this.facGetPvPmt(valueInstallments, rate, count)
                    //MONTA OBJETO
                    let data               = {portion:count, amortization: amortization.toFixed(2), valueInterest: valueInterest.toFixed(2), valueInstallments: valueInstallments.toFixed(2), balanceOwed: balanceOwed.toFixed(2), date: '', pv: pv}
                    allInstallments.push(data)

                }
                return allInstallments
            }

            let pmt = rateConvert * (fv / (interestRate - 1))
            return pmt.toFixed(2)
        },

        /**
         * CALCULO PARA OBTER PARCELA SAC
         * @param $valor
         * @param $taxa
         * @param $meses
         * @returns {number}
         */
        facGetInstallmentSac(value, rate, months, installments) {
            let interestRate = (rate / 100)
            let amortization = this.facGetAmortization(value, months)

            if(installments) {
                let allInstallments     = []
                let balanceOwed         = value
                let valueInterest       = 0
                let valueInstallments   = 0
                let pv                  = 0
                for (let count = 1; count <= months; count++) {
                    //VALOR DO JURO
                    valueInterest          = balanceOwed * interestRate
                    //VALOR DAS PARCELAS
                    valueInstallments      = amortization + valueInterest
                    //PEGA SALDO DEVEDOR
                    balanceOwed            = balanceOwed + valueInterest - valueInstallments
                    //PAGA VALOR DO PV
                    pv                     = this.facGetPvPmt(valueInstallments, rate, count)
                    //MONTA OBJETO
                    let data               = {portion:count, amortization: amortization.toFixed(2), valueInterest: valueInterest.toFixed(2), valueInstallments: valueInstallments.toFixed(2), balanceOwed: balanceOwed.toFixed(2), date: '', pv: pv}

                    allInstallments.push(data)
                    // console.log(valueInstallments.toFixed(2))
                }
                return allInstallments
            }
            //
            let pmt =  amortization + interestRate * value
            return pmt.toFixed(2)
        },

        /**
         * CALCULO PARA OBTER PARCELA SACOC
         * @param $valor
         * @param $taxa
         * @param $meses
         * @returns {number}
         */
        facGetInstallmentSacoc(value, rate, months, installment, valueInstallmentsUnit) {
            let interestRate = (rate / 100)
            let amortization = this.facGetAmortization(value, months)

            if(installment) {
                //PEGA AS CONDIÇÕES DA TABELA SAC QUE É O INVERSON DA TABELA SAC
                let installmentSac   = this.facGetInstallmentSac(value, rate, months, installment, valueInstallmentsUnit)
                //INVERTE O ARRAY PARA TRANSFORMAR NA TABELA SACOC
                let installmentSacoc = installmentSac.reverse()
                let count            = 1
                //ORDENA
                installmentSacoc.forEach(function (data) {
                    //
                    data.portion = count
                    count++
                })

                return installmentSacoc
            }

            let pmt =  amortization + (interestRate * (value - ((months - 1) * amortization)))
            return pmt.toFixed(2)
        },

        /**
         * CALCULO PARA OBTER PARCELAS VPL PARA SIMULAÇÂO DE INCORPORADORA
         *
         * @param valor
         * @param taxa
         * @param meses
         * @returns {*}
         * facGetInstallmentPrice
         */
        facGetInstallmentVertical(value, rate, period, months, installments, paymentOffset, vplOffset, dailyRate, dayOffset) {
            let offset = paymentOffset || 0
            let fv = this.facGetFV(value, rate, offset)
            let rateConvert  = (rate / 100)

            if (installments) {
                let allInstallments     = []
                let balanceOwed         = value
                let valueInterest       = 0
                let valueInstallments   = 0
                let amortization        = 0
                let pv                  = 0
                let portion             = 1

                for (let count = vplOffset; count < (months * period) + vplOffset; count += period) {
                    // VALOR DAS PARCELAS
                    valueInstallments      = fv / months
                    // VALOR DO JURO
                    valueInterest          = balanceOwed * rateConvert
                    // VALOR DA AMORTIZAÇÃO
                    amortization           = valueInstallments - valueInterest
                    // PEGA SALDO DEVEDOR
                    balanceOwed            = balanceOwed + valueInterest - valueInstallments
                    // PAGA VALOR DO PV
                    pv                     = this.facGetPvPmt(valueInstallments, rate, count)
                    
                    if (dailyRate) {
                        const dRate = Math.pow(1 + rateConvert, 1/30) - 1
                        pv = pv / Math.pow(1 + dRate, dayOffset)
                    }

                    // MONTA OBJETO
                    let data = {
                        portion,
                        amortization: amortization.toFixed(2),
                        valueInterest: valueInterest.toFixed(2),
                        valueInstallments: valueInstallments.toFixed(2),
                        balanceOwed: balanceOwed.toFixed(2),
                        date: '',
                        pv
                    }
                    allInstallments.push(data)
                    portion += 1
                }
                return allInstallments
            }
            let pmt = fv / months
            return pmt.toFixed(2)
        }
    }
}